export default __webpack_public_path__ + "static/media/Welcome-to-Member-Online-Header-Banner_2560x600.508c5b13.jpg";